import { AppThunk } from "@Store/index";
import { fetchPlusCategoriesDataIfNeeded } from "./plusCategoriesPageReducer";

const loadData = (props: any): AppThunk[] => [
  fetchPlusCategoriesDataIfNeeded(props),
  // More pre-fetched actions...
];

export default loadData;
